'use client'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

export default function HomeTestimonialSection() {
    return (
        <section className=" theme-pt-40 theme-pb-40 theme-pl-30 theme-pr-30">
            <div className="auto-container">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 theme-mb-30">
                        <div className="site-heading text-left">
                            <h2>DEPOIMENTOS</h2>
                            <p>A confiança de quem já fez negócio conosco</p>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mr-auto ml-auto">
                        <Swiper
                            id='testimonial'
                            modules={[Autoplay]}
                            autoplay={{
                                delay: 7000,
                                disableOnInteraction: false,
                            }}
                            spaceBetween={30}
                            loop={true}
                        >
                            <div className='swiper-wrapper'>
                                <SwiperSlide className='testimonial-item'>
                                    <div className="tcontent">
                                        <blockquote>
                                            <p>Vendedor Victor, com atendimento TOP atendeu todas nossas espectativas antes e depois de finalizar a nossa compra, tudo impecável do início ao fim.</p>
                                            <div className="testimonial-author">
                                                <p><strong className="font-weight-extra-bold">Gilson Souza</strong></p>
                                            </div>
                                        </blockquote>
                                        <div className="testimonial-arrow-down"></div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide className='testimonial-item'>
                                    <div className="tcontent">
                                        <blockquote>
                                            <p>Ótima ! Excelente atendimento do Cristiano e André !! Estou feliz com a minha aquisição !!</p>
                                            <div className="testimonial-author">
                                                <p><strong className="font-weight-extra-bold">Flávia de Oliveira Tarosso Batista</strong></p>
                                            </div>
                                        </blockquote>
                                        <div className="testimonial-arrow-down"></div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide className='testimonial-item'>
                                    <div className="tcontent">
                                        <blockquote>
                                            <p>Melhor loja para se adquirir o seu veículo, obg vendedor Junior pela atenção em todo processo, Deus abençoe sempre!</p>
                                            <div className="testimonial-author">
                                                <p><strong className="font-weight-extra-bold">William Dalves</strong></p>
                                            </div>
                                        </blockquote>
                                        <div className="testimonial-arrow-down"></div>
                                    </div>
                                </SwiperSlide>
                            </div>
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
}